import styled from "styled-components";

export const TitleWrapper = styled.div`
  max-width: 696px;
  & div:last-child {
    margin-top: 24px;
  }
`;
